import { Select } from '@material-ui/core';
import { Box, Card, FormControl, MenuItem } from '@mui/material';
import React from 'react';
import { getLanguageCookies, setLanguageCookies } from '../../../../utils/content-utils';
import Label from '../../../common/type/Label';

const selectedItems = [{
    'id': 'LanguaggePreferenceEnglish',
    'value': 'en',
    'label': 'LanguaggePreferenceEnglish',
    'className': 'languaggePreferenceEnglish'
},
{
    'id': 'LanguaggePreferenceSpanish',
    'value': 'es',
    'label': 'LanguaggePreferenceSpanish',
    'className': 'languaggePreferenceSpanish'
}];
const LanguageCard = () => {
    const [selectedValue, setSelectedValue] = React.useState('en');
    React.useEffect(() => {
        const language = getLanguageCookies();
        setSelectedValue(language);
    }, []);
    const handleChange = event => {
        setLanguageCookies(event.target.value);
        setSelectedValue(event.target.value);
        window.location.reload();
    };
    return (
        <Box className='securityBox'>
            <Card className='securityBoxHeader flexbox'>
                <h3 className='privacypolicy-section'>
                <Label id="settingsSetLanguageLabel" />
                                </h3>
                {selectedValue && <FormControl className='languageForm'>
                    <Select
                        id='demo-simple-select'
                        value={selectedValue}
                        onChange={handleChange}
                        displayEmpty
                        // inputprops={{ 'aria-label': 'Without label' }}
                        // style={{ width: 150, height: 48 }}

                        variant='outlined'
                    >
                        {selectedItems.map((item, index) => <MenuItem
                            key={index}
                            value={item.value}
                            className={item.className}
                            id={index}
                        >
                            <Label id={item.label} />
                        </MenuItem>)}

                    </Select>
                </FormControl>}
            </Card>
        </Box>
    );
};

export default LanguageCard;
